<ecp-hero title="Bulk Order Details" image="assets/images/headers/experts.jpg"> </ecp-hero>

<div class="container">
  <ecp-loader *ngIf="loading"></ecp-loader>
  <div class="col s12 is-flex is-fullwidth">
    <div class="mt-50">
      <mat-card class="mat-card mat-card--widget" *ngIf="orderDetails">
        <div class="row mt-10">
          <div class="col s12 mb-20">
            <button routerLink="/bulk-orders" class="btn btn-primary">Back to List</button>
          </div>
          <div class="col s4 m4">
            <h2>FileName:</h2>
            <h4>{{ formatFileName(orderDetails?.filename) }}</h4>
          </div>
          <div class="col s4 m4">
            <h2># of Lines:</h2>
            <h4>{{ orderDetails?.itemCount }}</h4>
          </div>
        </div>
        <div class="row ">
          <div class="col s4 m4">
            <h2>Upload Date:</h2>
            <h4>{{ orderDetails?.uploadedOn + 'Z' | date: 'short' }}</h4>
          </div>
          <div class="col s4 m4">
            <h2>Process Status:</h2>
            <h4>
              <ng-container *ngIf="orderDetails?.processStatus; else uploaded">
                <ng-container *ngIf="orderDetails?.processStatus?.toLowerCase() === 'processed'; else pendingIcon">
                  <mat-icon class="has-success" style="vertical-align: top;">check_circle</mat-icon>
                  {{ orderDetails?.processStatus }}
                </ng-container>
                <ng-template #pendingIcon>
                  <mat-icon class="has-warning" style="vertical-align: top;">error</mat-icon>
                  {{ orderDetails?.processStatus }}
                </ng-template>
              </ng-container>
              <ng-template #uploaded>
                <mat-icon class="has-warning" style="vertical-align: top;">error</mat-icon> Uploaded
              </ng-template>
            </h4>
          </div>
        </div>
        <hr />
        <mat-card class="mat-card">
          <ecp-bulk-order-details-table [mappedOrderList]="bulkOrderLineItems"></ecp-bulk-order-details-table>
        </mat-card>
      </mat-card>
    </div>
  </div>
</div>
